// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__nfHlH","animloader":"loader_animloader__B9pbw"};